'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _FormValidationService = require('./../../../../../common/services/FormValidationService');

var _FormValidationService2 = _interopRequireDefault(_FormValidationService);

var _lodash = require('lodash');

var _entityUserAddUserModal = require('./entityUser.addUser.modal.html');

var _entityUserAddUserModal2 = _interopRequireDefault(_entityUserAddUserModal);

var _entityUserUserPreferencesModal = require('./entityUser.userPreferences.modal.html');

var _entityUserUserPreferencesModal2 = _interopRequireDefault(_entityUserUserPreferencesModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EntityUserController = function () {
  function EntityUserController(entityService, loadingService, lookupService, appConfig, $scope, $uibModal, $timeout, enums) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EntityUserController);

    this.closeModal = function () {
      this.$uibModalInstance.close();
    };

    this.entityService = entityService;
    this.loadingService = loadingService;
    this.lookupService = lookupService;
    this.$scope = $scope;
    this.formValidationService = new _FormValidationService2.default();
    this.$uibModal = $uibModal;
    this.appConfig = appConfig;
    this.enums = enums;

    $timeout(this.setSearchUrl.bind(this), 7000);

    this.searchDisabled = true;
    this.searchUsersUrl = '';

    this.state = '';

    this.addUserError = '';

    this.user = {
      email: '',
      firstName: '',
      lastName: '',
      imageUrl: '',
      workType: 1
    };

    this.newUserName = '';

    this.addNewUser = false;

    this.configureForm();
    this.initializeLookups();

    this.uploadUrl = appConfig.apiServiceBaseUri + 'api/file/upload';
    this.mediaUrl = appConfig.apiServiceBaseUri + 'api/file/get';
    this.profilePicBaseUrl = appConfig.apiServiceBaseUri + 'api/file/updateprfilepic';
    this.profilePicUrl = '';
  }

  (0, _createClass3.default)(EntityUserController, [{
    key: 'setSearchUrl',
    value: function setSearchUrl() {
      this.searchUsersUrl = this.appConfig.apiServiceBaseUri + ('api/user/searchcompanyuser/' + this.entityId + '/');
      this.searchDisabled = false;
    }
  }, {
    key: 'toggleAddNewUser',
    value: function toggleAddNewUser() {
      this.addNewUser = !this.addNewUser;
    }
  }, {
    key: 'initializeLookups',
    value: function initializeLookups() {
      var _this = this;

      var entityUserCtrl = this;

      entityUserCtrl.lookupService.lookupRoles().then(function (roles) {
        entityUserCtrl.roles = roles;
        _this.tempRole = roles[0];
      });

      entityUserCtrl.lookupService.lookupBrands().then(function (brands) {
        entityUserCtrl.brands = brands;
        _this.tempBrand = brands[0];
      });
    }
  }, {
    key: 'configureForm',
    value: function configureForm() {
      var entityUserCtrl = this;

      entityUserCtrl.formValidationService.initialize(entityUserCtrl.user);

      entityUserCtrl.formValidationService.addField({
        fieldName: 'email',
        displayName: 'Email',
        required: true,
        stringLength: {
          min: 5,
          max: 50
        }
      });

      entityUserCtrl.formValidationService.addField({
        fieldName: 'firstName',
        displayName: 'First Name',
        required: true,
        stringLength: {
          min: 3,
          max: 50
        }
      });

      entityUserCtrl.formValidationService.addField({
        fieldName: 'lastName',
        displayName: 'Last Name',
        required: true,
        stringLength: {
          min: 3,
          max: 50
        }
      });
    }
  }, {
    key: 'addUser',
    value: function addUser() {
      var _this2 = this;

      var entityUserCtrl = this;

      if (!entityUserCtrl.formValidationService.validateForm()) {
        return;
      }

      this.state = 'Saving';

      entityUserCtrl.loadingService.showLoading('addUser', 'Saving Changes ...');

      entityUserCtrl.entityService.addUser(entityUserCtrl.user).then(function (response) {
        entityUserCtrl.state = 'Saved';

        entityUserCtrl.newUserName = entityUserCtrl.user.firstName + ' ' + entityUserCtrl.user.lastName;
        entityUserCtrl.selectedUser = {
          originalObject: entityUserCtrl.user
        };
        entityUserCtrl.selectedUser.originalObject.userId = response.data;
        _this2.closeModal();
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          entityUserCtrl.state = 'ModelError';

          err.data.map(function (item) {
            entityUserCtrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        } else if (err.status === 500) {
          entityUserCtrl.state = 'SystemError';
          entityUserCtrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      }).finally(function () {
        entityUserCtrl.loadingService.hideLoading('addUser');
      });
    }
  }, {
    key: 'addEntityUser',
    value: function addEntityUser() {
      var entityUserCtrl = this;
      var entityUsers = this.entityUsers;

      if (!entityUserCtrl.selectedUser || !entityUserCtrl.selectedUser.originalObject) {
        entityUserCtrl.addUserError = 'Please select a User to add';
        return;
      }

      var userAccess = (0, _lodash.filter)(entityUsers, function (eu) {
        return eu.userId === entityUserCtrl.selectedUser.originalObject.userId;
      });

      if (userAccess.length) {
        var roleId = userAccess[0].roleId;
        var brandIds = userAccess.map(function (eu) {
          return eu.brandId;
        });

        if (roleId !== entityUserCtrl.tempRole.roleId) {
          this.addUserError = 'Adding multiple roles for a User is not possible';

          return;
        }

        if ((0, _lodash.find)(brandIds, function (id) {
          return id === entityUserCtrl.tempBrand.brandId;
        })) {
          this.addUserError = 'User ' + userAccess[0].userName + ' has been already been given access to ' + entityUserCtrl.tempBrand.name;

          return;
        }
      }

      entityUsers.push({
        userId: entityUserCtrl.selectedUser.originalObject.userId,
        userName: entityUserCtrl.selectedUser.originalObject.firstName + ' ' + entityUserCtrl.selectedUser.originalObject.lastName,
        roleId: entityUserCtrl.tempRole.roleId,
        roleName: entityUserCtrl.tempRole.name,
        brandId: entityUserCtrl.tempBrand.brandId,
        brandName: entityUserCtrl.tempBrand.name,
        userPreferences: {
          entityId: entityUserCtrl.entityId,
          userId: entityUserCtrl.selectedUser.originalObject.userId
        }
      });

      entityUserCtrl.addUserError = '';
      entityUserCtrl.$scope.$broadcast('angucomplete-alt:clearInput', 'searchUsers');
      entityUserCtrl.selectedUser = null;
      entityUserCtrl.tempRole = entityUserCtrl.roles[0];
      entityUserCtrl.tempBrand = entityUserCtrl.brands[0];
    }
  }, {
    key: 'removeEntityUser',
    value: function removeEntityUser(entityUser) {
      this.entityUsers = (0, _lodash.without)(this.entityUsers, entityUser);
    }
  }, {
    key: 'addUserModal',
    value: function addUserModal() {
      this.addUserError = '';

      this.$uibModalInstance = this.$uibModal.open({
        template: _entityUserAddUserModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'onImageUploaded',
    value: function onImageUploaded(response) {
      this.user.imageUrl = response.data[0].value;
    }
  }, {
    key: 'onImageUploadedPref',
    value: function onImageUploadedPref(response) {
      this.userPreferences.imageUrl = response.data;
    }
  }, {
    key: 'showUpdateUserPref',
    value: function showUpdateUserPref(userPreferences) {
      this.landingPageOptions = [{ id: 0, name: 'Welcome Centre' }, { id: 1, name: 'Dashboard' }, { id: 2, name: 'Lead Monitor WebEnquiries Today' }, { id: 3, name: 'Lead Monitor WebEnquiries This Week' }, { id: 4, name: 'Lead Monitor WebEnquiries Last Week' }, { id: 5, name: 'Lead Monitor Enquiries Today' }, { id: 6, name: 'Lead Monitor Enquiries This Week' }, { id: 7, name: 'Lead Monitor Enquiries Last Week' }];

      this.userPreferences = userPreferences;
      this.userPreferences.userTitle = userPreferences.firstName + ' ' + userPreferences.lastName;
      this.profilePicUrl = this.profilePicBaseUrl + '/' + userPreferences.userId;

      this.$uibModalInstance = this.$uibModal.open({
        template: _entityUserUserPreferencesModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'updateUserPref',
    value: function updateUserPref(userPreferences) {
      var _this3 = this;

      var listPref = (0, _lodash.find)(this.entityUsers, function (eu) {
        return eu.userId === _this3.userPreferences.userId;
      });
      listPref.userName = this.userPreferences.firstName + ' ' + this.userPreferences.lastName;

      this.entityService.updateUserPreferences(this.userPreferences);
      this.closeModal();
    }
  }]);
  return EntityUserController;
}();

exports.default = EntityUserController;


// WEBPACK FOOTER //
// ./client/app/components/admin/entity/edit/entityUser/entityUser.controller.js